import classNames from 'classnames/bind';
import styles from './TipDetail.module.scss';
import MarkdownViewer from '../../Layouts/components/MarkdownViewer';
import { useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { getData } from '~/helper/apiService';
import useMeta from '~/hooks/useMeta';

const cx = classNames.bind(styles);

function TipDetail() {
  const { id } = useParams();
  const [tip, setTip] = useState(null);

  const loadTip = async () => {
    try {
      const data = await getData(`/tips/read/${id}`);
      setTip(data);
    } catch (error) {
      console.error('Lỗi khi tải dữ liệu tip:', error);
    }
  };

  useEffect(() => {
    loadTip();
  }, [id]);

  useMeta({
    title: tip ?  `${tip?.title } | Ngô Gia Quyến` : "Ngô Gia Quyến - Blog Cá Nhân",
    description: 'Cách triển khai dự án Django lên Render với hướng dẫn chi tiết từng bước, từ tạo project Django đến push code và cấu hình trên Render.',
    keywords: 'Django, Render, deploy, Python, web development, hosting, GitHub, gunicorn, API, tutorial',
    author: 'Ngô Gia Quyến',
    image: '/path/to/deploy-image.jpg',
    url: `https://ngogiaquyen.id.vn/tip-detail/${id}`,
  });

  if (!tip) {
    return <div className={cx('loading')}>Đang tải...</div>;
  }



  return (
    <div className={cx('wrapper')}>
      <h1 className={cx('title')}>{tip.title}</h1>
      <p className={cx('meta')}>
        <span className={cx('date')}>Ngày tạo: {new Date(tip.date_create).toLocaleString()}</span>
        <span className={cx('type')}>Loại: {tip.type_name}</span>
      </p>
      <MarkdownViewer content={tip.content} />
    </div>
  );
}

export default TipDetail;
